var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolunteers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2871 26.998L17.3557 27.3544C18.9892 27.8985 20.5814 28.5714 22.0759 29.4234C22.4052 29.6112 22.7585 29.7526 23.1258 29.8441",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7281 26.6075C29.7281 26.6068 29.7288 26.6068 29.7288 26.6061C30.2078 25.5245 30.2185 24.2458 29.6469 23.1064L28.8711 21.5557",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0898 17.999C27.0905 17.9997 27.0898 17.9997 27.0898 17.9997L28.8704 21.5558",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4554 20.2743L21.502 18.3691",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3318 32.3961L31.4158 30.8605C32.2802 30.4305 32.6315 29.3821 32.1997 28.5201L31.702 27.5247C31.3307 26.7842 30.5036 26.4212 29.7291 26.6064C29.602 26.6375 29.4763 26.6827 29.3545 26.743L23.1259 29.8439L22.8591 29.9767C21.9948 30.4073 21.6435 31.4551 22.0753 32.3177L22.573 33.3124C23.0048 34.1751 24.0561 34.5248 24.9205 34.0948L26.3291 33.3934",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8405 9.66992C26.9057 10.0422 26.919 10.4218 26.8804 10.798C26.7041 12.506 26.732 14.23 26.8943 15.9401L27.086 17.9514C27.0873 17.9673 27.0886 17.9832 27.0893 17.9991C27.09 17.9998 27.0893 17.9998 27.0893 17.9998C27.1399 18.8087 26.5271 19.5154 25.7047 19.5698C24.8969 19.6242 24.2002 19.0044 24.1237 18.2009L23.6992 15.7178",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.916 7.78693L18.0231 6.45141C18.8372 5.46839 20.0144 4.96023 21.2004 4.95996",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.834 14.3395L16.9638 11.7715",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2554 15.2974C13.0225 15.2669 12.7956 15.1727 12.6013 15.0128C12.0517 14.5595 11.9745 13.7473 12.429 13.1992L15.5296 9.45996",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7725 13.6338L17.4551 15.2231",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5605 17.874L20.3012 15.7744",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.293 21.0343L21.502 18.3694L23.6997 15.7178",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7989 5.31187L30.0123 6.31221C30.7571 6.92635 30.8617 8.02642 30.2459 8.7693L29.5356 9.62617C28.9198 10.369 27.8167 10.4734 27.0718 9.85922L21.4768 5.24604C20.7319 4.6319 20.6273 3.53182 21.2431 2.78895L21.9534 1.93208C22.5692 1.1892 23.6723 1.08489 24.4172 1.69903L27.0739 3.88949",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69357 19.7906L8.63768 17.3572C8.61912 16.5501 7.96865 15.882 7.15895 15.8789C6.31838 15.8747 5.64629 16.5627 5.66545 17.395L5.71196 19.4149C5.75148 21.1317 5.6554 22.8535 5.35738 24.5443C5.29131 24.9171 5.27794 25.2967 5.31593 25.6726",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5826 26.6885L16.2865 26.9977L13.8798 29.5113C12.9975 30.4337 11.7866 30.8564 10.6035 30.7721",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5832 26.6884L19.9447 23.1794C20.4371 22.6651 20.4185 21.8503 19.9028 21.3585C19.7265 21.1913 19.5155 21.0832 19.294 21.0341C19.1908 21.0102 19.0857 21.0002 18.9812 21.0022C18.6506 21.0102 18.3232 21.1435 18.077 21.4003L17.8701 21.6167L15.3184 24.2803",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0755 21.4008L19.373 20.0464C19.866 19.5322 19.8474 18.7166 19.3311 18.2249C19.1122 18.0172 18.84 17.9004 18.5606 17.8739C18.5107 17.8692 18.4601 17.8672 18.4095 17.8686C18.0795 17.8765 17.7515 18.0092 17.5053 18.2667L14.1172 21.8049",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88281 19.8634L13.7959 14.7334C14.0425 14.476 14.37 14.3429 14.7003 14.3353C15.0307 14.3277 15.364 14.4457 15.6221 14.6916C16.0619 15.1105 16.1404 15.7646 15.8483 16.2676C15.7981 16.3544 15.7364 16.4372 15.664 16.5128L12.7902 19.5135",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5051 18.2669L18.3355 17.4003C18.8285 16.8853 18.8099 16.0705 18.2936 15.5788C18.0567 15.3545 17.7573 15.2357 17.4539 15.2238C17.4266 15.2224 17.3986 15.2224 17.3714 15.2231C17.3448 15.2238 17.3188 15.2251 17.2922 15.2277C16.9901 15.2523 16.694 15.3843 16.4678 15.6206L15.8477 16.2682",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05076 29.879L1.91237 28.7946C1.21346 28.1289 1.18805 27.0242 1.85555 26.3272L2.62552 25.5232C3.29303 24.8262 4.40074 24.8008 5.09965 25.4665L10.3494 30.4671C11.0483 31.1328 11.0737 32.2375 10.4062 32.9346L9.63625 33.7386C8.96874 34.4356 7.86103 34.4609 7.16212 33.7952L4.66936 31.4208",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteers);
export default __webpack_public_path__ + "static/media/volunteers.71512ce748e52db4dac333cc4b26f76b.svg";
export { ForwardRef as ReactComponent };